<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
      <div class="flex flex-wrap items-center justify-between mb-10">
        <div class="flex items-center">
          <h4 style="margin-left: 10px">Users</h4>
        </div>
        <div class="flex items-center">
          <vs-button @click="refreshData" class="mb-4 mr-1 btn md:mb-0" icon="refresh">Refresh</vs-button>
          <vs-button :to="{ name: 'user-add' }" class="mb-4 mr-1 btn md:mb-0" icon="add">Add</vs-button>
          <vs-button
            :to="{ name: 'user-view', params: {id: selectedId} }"
            class="mb-4 mr-1 md:mb-0"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 mr-1 md:mb-0"
            @click="filterActive"
            icon="filter_list"
          >Filter</vs-button>
          <!-- <vs-button class="mb-4 mr-1 md:mb-0" @click="removeItem" icon="delete" :disabled="selectedId ? false : true">Delete</vs-button> -->
          <!-- <vs-button class="mb-4 mr-1 md:mb-0" icon="filter_list">Filter</vs-button> -->
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="my-4 ag-theme-material w-100 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="tableData"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
        rowHeight="35"
        headerHeight="35"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="filter.username" class="w-full mb-2" label="Username" />
          <vs-input v-model="filter.email" class="w-full mb-2" label="Email" />
          <vs-select
              class="selectExample"
              v-model="filter.user_type"
              width="100%"
              label="User Type"
          >
              <vs-select-item value="Regular" text="Regular"/>
              <vs-select-item value="Client" text="Client"/>
          </vs-select>
          <vs-select
                class="selectExample"
                v-model="filter.client_id"
                width="100%"
                autocomplete
                label="Client"
            >
                <vs-select-item v-for="(item, index) in client" :key="index" :value="item.id" :text="item.name"/>
            </vs-select>
            <vs-select
                class="selectExample"
                v-model="filter.user_group_id"
                width="100%"
                autocomplete
                label="User Group"
            >
                <vs-select-item v-for="(item, index) in usergroup" :key="index" :value="item.id" :text="item.name"/>
            </vs-select>
          <vs-select
              class="selectExample"
              v-model="filter.status"
              width="100%"
              label="Status"
          >
              <vs-select-item value="1" text="Active"/>
              <vs-select-item value="0" text="Inactive"/>
          </vs-select>
          <!-- <vs-input v-model="filter.created_at" class="w-full mb-2" label="Created At" /> -->
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
      <!-- <vs-prompt
            @accept="searchDO"
            :active.sync="activeSearchDO"
            title="Search Outbound"
            >
            <div class="con-exemple-prompt">
                <vs-input placeholder="Outbound Reference *" v-model="data.outbound_reference" class="w-full mt-4 mb-2" />
                <v-select :options="clientOptions" v-model="data.client" label="name" @search="searchClient" :clearable="false" placeholder="Client *"></v-select>

                <vs-alert v-if="doSearchError" color="danger" vs-icon="new_releases" class="mt-10" >
                    {{ doSearchError }}
                </vs-alert>
            </div>
      </vs-prompt>-->
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      tableData: [],
      selectedId: null,
      isLoading: false,
      totalPage: 1,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,
      filter: {
        username: "",
        email: "",
        user_group_id: "",
        client_id: "",
        user_type: "",
        status: "",
      },
      showFilterForm: false,
      client: [],
      usergroup: [],
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this user?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("outbound/deliveryorder/" + this.selectedId + "/destroy")
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "User deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected user was successfully deleted"
          });
        })
        .catch(error => {
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            title: "Error",
            text: message,
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    refreshData() {
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post("rolemanagement/users?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.tableData = [];
          resp.data.data.map(user => {
            const data = {
              id: user.id,
              username: user.username,
              email: user.email,
              user_group: user.name,
              user_type: user.user_type,
              client_id: user.client_id ? user.client_code : null,
              status: user.status == 1 ? 'Active' : 'Inactive',
            };

            this.tableData.push(data);
          });
          this.totalPage = resp.data.last_page;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.currentPage = resp.data.current_page;
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Something went wrong",
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    viewData() {
      this.$router.push({
        name: "user-view",
        params: {
          id: this.selectedId
        }
      });
    },
    filterData() {
      this.currentPage = 1;
      this.fetchData();
      this.showFilterForm = false;
    },
    filterActive() {
        this.showFilterForm = !this.showFilterForm;
        Promise.all([
            this.$http.post("master/clients"),
            this.$http.post('rolemanagement/usergroup')
        ])
            .then(
                this.$http.spread((clientData, usergroups) => {
                    this.client = clientData.data.data;
                    this.usergroup = usergroups.data.data;
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                })
            )
            .catch(() => {
                this.maxRetry = this.maxRetry - 1;
                if (this.maxRetry < 0) {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                    return;
                }
                this.fetchData();
            });
    },
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "ID",
        field: "id",
        width: 100,
        hide: true
        // checkboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // headerCheckboxSelection: true,
      },
      {
        headerName: "User Name",
        field: "username",
        width: 150,
        // checkboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // headerCheckboxSelection: true,
      },
      {
        headerName: "Email",
        field: "email",
        width: 150
      },
      {
        headerName: "User Group",
        field: "user_group",
        width: 150
        // pinned: 'left'
      },
      {
        headerName: "User Type",
        field: "user_type",
        width: 150
      },
      {
        headerName: "Client ID",
        field: "client_id",
        width: 150
      },
      {
        headerName: "Status",
        field: "status",
        width: 150
      },
    ];
  }
};
</script>
